import React, { useState } from "react";

const TermsModal = ({ onClose, onConfirm }) => {
  const [accepted, setAccepted] = useState(false);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-md p-6 text-left max-h-[90vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-black hover:text-black text-2xl font-bold"
          aria-label="Close"
        >
          &times;
        </button>

        <h2 className="text-lg font-semibold mb-4 text-center">
          Terms & Conditions
        </h2>

        <div className="text-sm font-medium text-gray-800 space-y-3 max-h-60 overflow-y-auto border p-3 rounded-md">
          <p>
            Welcome! Please review our terms and conditions carefully before
            proceeding. These include but are not limited to data usage, privacy
            policies, and your responsibilities as a user.
          </p>
          <p>
            Welcome! Please review our terms and conditions carefully before
            proceeding. These include but are not limited to data usage, privacy
            policies, and your responsibilities as a user.
          </p>{" "}
          <p>
            Welcome! Please review our terms and conditions carefully before
            proceeding. These include but are not limited to data usage, privacy
            policies, and your responsibilities as a user.
          </p>{" "}
          <p>
            Welcome! Please review our terms and conditions carefully before
            proceeding. These include but are not limited to data usage, privacy
            policies, and your responsibilities as a user.
          </p>
          <p>
            By accepting, you agree to comply with all policies described and
            acknowledge that you have read and understood the terms.
          </p>
          {/* Add more content here as needed */}
        </div>

        <div className="mt-4 flex items-center space-x-2">
          <input
            id="accept"
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="  border-2 border-[#FF5050] rounded h-4 w-4 custom-checkbox checked:border-[#375AE7] checked:bg-[#375AE7] relative"
          />
          <label htmlFor="accept" className="text-sm font-medium text-gray-800">
            I accept the Terms and Conditions
          </label>
        </div>

        <div className="mt-6 flex justify-between font-medium space-x-4">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-black text-black rounded-full font-medium hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={() => accepted && onConfirm()}
            disabled={!accepted}
            className={`flex-1 px-4 py-2 rounded-full font-medium ${
              accepted
                ? "bg-[#375AE7] text-white hover:bg-gray-800"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
            }`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
